import { Link } from 'react-router-dom';
import { ShieldOff, Plus, Settings } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/app/components/ui/card';
import { usePermissions } from '@/hooks/use-permissions';
import { getModuleDisplayName } from '@/lib/modules';

interface ModuleDisabledStateProps {
  moduleKey: string;
}

export function ModuleDisabledState({ moduleKey }: ModuleDisabledStateProps) {
  const { isAdmin } = usePermissions();
  const moduleName = getModuleDisplayName(moduleKey);

  return (
    <Card>
      <CardHeader className="flex flex-col items-center text-center py-12">
        <ShieldOff className="h-12 w-12 text-gray-400 mb-4" />
        <CardTitle className="text-xl">{moduleName} is not enabled</CardTitle>
        <CardDescription className="max-w-md mt-2">
          This module has not been enabled for your organization. Contact your administrator to enable it, or add it to your subscription.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center gap-3 pb-8">
        <Button asChild>
          <Link to="/settings/upgrade">
            <Plus className="h-4 w-4 mr-2" />
            Add Module
          </Link>
        </Button>
        {isAdmin && (
          <Button variant="outline" asChild>
            <Link to="/settings/modules">
              <Settings className="h-4 w-4 mr-2" />
              Manage Modules
            </Link>
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
